define('TescoMobile_Catalog/js/action-bar',['jquery', 'matchMedia', 'Magento_Theme/js/model/scroll-shadow-mutation-observer', 'domReady!'], function ($, mediaCheck, scrollShadowMutationObserver) {
  'use strict';

  return function (config, el) {
    var globalOptions = {
      headerHeight: 0,
      scrollPosition: 0,
      showDeliveryTimer: true
    };
    var rbd = rbd || {};
    rbd.actionBar = {
      options: globalOptions,
      init: function () {
        var _self = this;
        mediaCheck({
          media: '(min-width: 1008px)',
          entry: function () {
            _self.options.headerHeight = _self._getHeaderHeight('desktop');
          },
          exit: function () {
            _self.options.headerHeight = _self._getHeaderHeight('mobile');
            _self._setScrollableItems();
          }
        });
        if ($('.action-bar-delivery-timer .delivery-counter-wrapper').length > 0) {
          $('.action-bar__content').hide();
        }
        this._setBarSticky(this.options.headerHeight);
        this._screenResizeFixer();
      },
      _setScrollableItems: function () {
        if ($('.scrollable-block .pagebuilder-column-group').length > 0) {
          scrollShadowMutationObserver.setShadow('.scrollable-block', '.scrollable-block .pagebuilder-column-group', '.scrollable-block .pagebuilder-column-group .pagebuilder-column');
        } else {
          scrollShadowMutationObserver.initiate('.scrollable-block', '.scrollable-block .pagebuilder-column-group', '.scrollable-block .pagebuilder-column-group .pagebuilder-column', function () {});
        }
      },
      _setBarSticky: function (hh) {
        var _self = this;
        if (hh > 0) {
          $(window).on('scroll', function () {
            var actionBarContainer = $('.action-bar');
            _self.options.scrollPosition = $(document).scrollTop();
            _self.options.scrollPosition > _self.options.headerHeight ? actionBarContainer.parent().addClass('_stickybar') : actionBarContainer.parent().removeClass('_stickybar');
            _self._deliverTimer(_self.options.scrollPosition);
          });
        }
      },
      _deliverTimer: function (scrollPosition) {
        var _self = this;
        if ($('.action-bar-delivery-timer .delivery-counter-wrapper').length > 0) {
          var offset = $('.product-info-main .product-info-price').offset().top;
          if (scrollPosition > offset && _self.options.showDeliveryTimer) {
            $('.action-bar-delivery-timer').fadeOut(120).prev().delay(120).fadeIn(80);
            _self.options.showDeliveryTimer = false;
          }
        }
      },
      _screenResizeFixer: function () {
        var _self = this;
        $(window).on('resize', function () {
          if ($(window).width() > 1008) {
            _self.options.headerHeight = _self._getHeaderHeight('desktop');
          } else {
            _self.options.headerHeight = _self._getHeaderHeight('mobile');
          }
        });
      },
      _getHeaderHeight: function (screen) {
        var hh = 0;
        if (screen === 'desktop') {
          hh = $('.page-header').outerHeight(true) + $('.nav-sections').outerHeight(true);
        } else {
          hh = $('.page-header').outerHeight(true);
        }
        return hh;
      }
    };
    rbd.actionBar.init();
  };
});

